























import { Component, Vue, Prop } from 'vue-property-decorator';
import PensionUnitSelectionShow from '@/components/PensionUnitSelection/PensionUnitSelectionShow.vue';
import { GQL_pensionUnitSelections_currentUnit_pensionUnitSelections } from '@/queries/__generated__/pensionUnitSelections';

@Component({
  components: {
    PensionUnitSelectionShow,
  },
})
export default class PensionUnitSelectionShowButton extends Vue {
  @Prop() private pensionUnit!: GQL_pensionUnitSelections_currentUnit_pensionUnitSelections;
  private showDialog = false;
}
